import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { PxdAgGridNumericEditorComponent } from "@app/shared/aggrid/pxd-ag-grid-numeric-editor";
import { PxdAgGridColumnTypes, PxdAgGridDefaultColumnDef, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from "@app/shared/aggrid/pxd-ag-grid-options";
import { ButtonLoadingDirective } from "@app/shared/directives/button-loading/button-loading.directive";
import { kendoIcons } from "@app/shared/library/kendo-icons";
import { IUpliftDto } from "@app/shared/models/dtos/uplifts";
import { ButtonDirective } from "@progress/kendo-angular-buttons";
import { AgGridAngular } from "ag-grid-angular";
import { CellValueChangedEvent, ColDef, GridApi, GridReadyEvent, } from "ag-grid-community";
import { UpliftsService } from "./uplifts.service";

@Component({
  selector: "app-uplifts",
  templateUrl: "./uplifts.component.html",
  styleUrls: ["./uplifts.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ButtonDirective,
    ButtonLoadingDirective,
    AgGridAngular,
  ],
})
export class UpliftsComponent {
  private service = inject(UpliftsService);

  gridOptions: PxdAgGridOptions = {
    cellSelection: true,
    rowGroupPanelShow: 'never',
    defaultColDef: PxdAgGridDefaultColumnDef,
    statusBar: PxdAgGridStatusBarOptions,
    sideBar: PxdAgGridSideBarOptions,
    columnTypes: PxdAgGridColumnTypes,
    columnDefs: [],
  };
  gridApi: GridApi;
  data: IUpliftDto[];
  editedEntities: Map<number, IUpliftDto> = new Map<number, IUpliftDto>();
  public editMode: boolean = false;
  public loading: boolean = true;
  public icons = kendoIcons;

  async onGridReady(e: GridReadyEvent) {
    this.gridApi = e.api;
    this.loadGrid();
  }

  async loadGrid(refresh: boolean = true) {
    this.loading = true;
    if (refresh) {
      this.data = await this.service.loadData();
    }

    let currentYear = new Date().getFullYear();
    let columnDefs = new Map<string, ColDef>();
    columnDefs.set("ProjectType", { field: 'ProjectType', headerName: 'Project Type' })
    let keys = Object.keys(this.data[0])
    keys.forEach(x => {
      if (x.includes("Year") && x.includes("Percent")) {
        columnDefs
          .set(x,
            {
              field: x,
              headerName: (currentYear + Number(x.replace("Year", "").replace("Percent", ""))).toString(),
              editable: true,
              width: 70,
              type: ['numberColumn'],
              valueFormatter: params => `${Math.round((params.value * 10000) / 100)}%`,
              cellEditorSelector: params => {
                return {
                  component: PxdAgGridNumericEditorComponent,
                  params: {
                    decimals: 4,
                    format: "p"
                  }
                };
              }
            });
      }
    })

    this.gridApi.setGridOption('columnDefs', Array.from(columnDefs.values()))
    this.gridApi.setGridOption('rowData', this.data);
    this.loading = false;
  }

  onCellValueChanged(e: CellValueChangedEvent) {
    if (e.oldValue === e.newValue) return;
    this.editMode = true;
    this.editedEntities.set(e.data.UpliftPercentId, e.data);
  }

  async onSave(e) {
    this.loading = true;
    await this.service.saveData(Array.from(this.editedEntities.values()));
    this.editMode = false;
    this.editedEntities = new Map<number, IUpliftDto>();
    this.loadGrid();
  }

  onCancel(e) {
    this.editMode = false;
    this.editedEntities = new Map<number, IUpliftDto>();
    this.loadGrid();
  }
}